
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ReactiveFormsModule, Validators, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../../../services/auth/auth.service';
import { AdministrationService } from '../../../../services/administration/administration.service';
import { environment } from '../../../../../environments/environment';
import { ToastModule } from 'primeng/toast';
import { LoaderService } from '../../../../services/loader/loader.service';


@Component({
  selector: 'app-signup-form',
  imports: [
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    InputTextModule,
    CheckboxModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './signup-form.component.html',
  styles: ``
})
export class SignupFormComponent {
  userForm = new FormGroup({
    first_name: new FormControl(null, [
      Validators.required,
      Validators.maxLength(15),
      Validators.pattern(/^[A-Za-z\s'-]+$/)
    ]),
    last_name: new FormControl(null, [
      Validators.required,
      Validators.maxLength(15),
      Validators.pattern(/^[A-Za-z\s'-]+$/)
    ]),
    email: new FormControl(null, [
      Validators.required,
      Validators.maxLength(254),
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ]),
    organisation_name: new FormControl(null, [Validators.maxLength(50)]),
  })
  private loaderService = inject(LoaderService);
  adminService = inject(AdministrationService);
  showPassword = false;
  isChecked = false;
  submitting = false;
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  constructor(private authService: AuthService, private messageService: MessageService, private router: Router) { }
  async registerUser() {

    if (this.submitting || this.userForm.invalid) return;
    this.submitting = true;
    this.loaderService.show();

    try {

      const payload = {
        ...this.userForm.value,
        is_pending: true
      };
      const response = await fetch(
        environment.baseApiUrl + 'user/v1/user/register',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );
      const data = await response.json();
      if (response.ok) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.message || 'Registration successful!'
        });

        this.userForm.reset();

        setTimeout(() => {
          this.router.navigate(['/pending-user']);
        }, 1000);
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: data?.message || data?.detail || 'Registration failed!'
        });
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Something went wrong. Please try again later.'
      });
    } finally {
      // always hide loader
      this.loaderService.hide();
      this.submitting = false;
    }
  }


}
